import { Component, OnInit, ViewChild ,Input} from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { WebParameterContext } from '../../../model/common';
import { Platform, IonInfiniteScroll, ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../service/messageclient.service';
declare var app;
@Component({
  selector: 'app-reasons-differences',
  templateUrl: './reasons-differences.page.html',
  styleUrls: ['./reasons-differences.page.scss'],
})
export class ReasonsDifferencesPage extends GridBaseCase implements OnInit {
  cravingforRemk:string = ""; // 差异原因
  reasonsforDifferencesList:Array<any>=[];
  modalSHOEremark:boolean=false; // 是否显示差异原因
  seceltName:string=""; // 选择的名字
  FK_TBReasonsProductInventoryDifferences_ID:string="";// 选择的id
  cravingforRemkbh:string =""; // 驳回
  _type:"";
  @Input() reasonsforDifferenceslo:any;
  @Input() fisttype:any;

  @Input() srltype:any; // 盘库差异原因
  
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public modalController: ModalController,
  ) {
    super();
   }

  ngOnInit() {
    console.log(this.reasonsforDifferenceslo);

    // this.reasonsforDifferences();
    this.reasonsforDifferencesList = this.reasonsforDifferenceslo;
    console.log(this.srltype)
     
  }
  EventSelect(item){
    const that =this;
    that.cravingforRemk ="";
    // item.isCheck =false;
    that.reasonsforDifferencesList.forEach(items=>{
      items["isCheck"]= false;
      if(item.a_ID == items.a_ID){
        items["isCheck"]= true;
      }
    });
    console.log(item,"点击")
    if(item.a_Name == "其它"){
      that.modalSHOEremark = true;
    }else{
      that.modalSHOEremark = false;
    }
    // item.isCheck = item.a_ID;
    that.seceltName =item.a_Name;
    that.FK_TBReasonsProductInventoryDifferences_ID = item.a_ID
    that._type=item;
    
  }
    // 取消
    dismissModal() {
      const that=this;
      this.modalController.dismiss({
        "modalStatus": false,
        "type": that._type,
        "info": '0',
        "cravingforRemk":"",
        "seceltName":"",
        backurl:"1"
      });
    }
    // 确定
    comfireModal() {
        const that=this;
        that.cravingforRemk = that.cravingforRemk.replace(/(^\s*)|(\s*$)/g, "")
          if(that.cravingforRemk.length==0 ){
            if(that.seceltName == "其它"){
              that.msg.Alert("差异原因不能为空");
              return;
            }
           
          }
          if(that.fisttype){
            that.modalController.dismiss({
              "modalStatus": true,
              "type": that._type,
              "info": "是的",
              "cravingforRemk":that.cravingforRemk,
              "seceltName":that.seceltName || that.fisttype.a_Name,
              "FK_TBReasonsProductInventoryDifferences_ID":that.FK_TBReasonsProductInventoryDifferences_ID || that.fisttype.a_ID
  
            });
          }else if(that.srltype == '驳回'){
            that.modalController.dismiss({
              "modalStatusvalue": that.cravingforRemkbh,
              'backurl':"1"
             
  
            });
          }
         
          // console.log(item,"确定mmmmm")
          // item.seceltName = that._type.a_Name;
          // item.cravingforRemk = that.cravingforRemk;
          // item.Remark = that.cravingforRemk;
          // item.modalSHOE = false;
          // item.FK_TBReasonsProductInventoryDifferences_ID = that._type.a_ID;
       
      
     
    }
    // 差异原因
    RemarkInputcravingfor(e){
      let that = this;
      console.log( e.target.value)
      e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
      console.log( typeof e.target.value)
      if (e && e.target.value) {
        if (e.target.value.length > 120) {
          e.target.value = e.target.value.substr(0, 120);
          that.cravingforRemk = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
        }
      }
    }
      // 差异原因
      RemarkInputcravingforbh(e){
        let that = this;
        console.log( e.target.value)
        e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
        console.log( typeof e.target.value)
        if (e && e.target.value) {
          if (e.target.value.length > 120) {
            e.target.value = e.target.value.substr(0, 120);
            that.cravingforRemkbh = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
          }
        }
      }
    /**
     * 差异原因
     */
     reasonsforDifferences(){
      let that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
        body.ConfigName = "TBReasonsProductInventoryDifferencesXML";
      // body.ConfigName="MemberManage";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        if (data.ResponseMessage.Success) {
         let  _reasonsforDifferencesList =  data.Status.Datas[0];
         that._type = _reasonsforDifferencesList;
          data.Status.Datas.forEach(items=>{
            items["isCheck"]= false;
            if(_reasonsforDifferencesList.a_ID == items.a_ID){
              items["isCheck"]= true;
            }
          });
          that.reasonsforDifferencesList= data.Status.Datas;
         
          console.log(that.reasonsforDifferencesList,"差异原因")
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
    }
}
